import { useCallback } from 'react';
import { useCounter } from './useCounter';
export const useCopy = (text, copyTimer = 3) => {
    const { isCounterRunning, counterInterval } = useCounter(copyTimer);
    const handleCopy = useCallback(() => {
        if (isCounterRunning)
            return;
        navigator.clipboard.writeText(text);
        counterInterval();
    }, [counterInterval, isCounterRunning, text]);
    return { isCounterRunning, handleCopy };
};
//# sourceMappingURL=useCopy.js.map